// vendors
import React from "react"
import { getFluidGatsbyImage } from "gatsby-source-sanity"
import { css } from "@emotion/core"
import { fonts, colors, fontSizes } from "../../styles/variables"
import { greaterThen, lessThen } from "../../utils/media-query"

const sanityConfig = { projectId: "ao0tzm5m", dataset: "production" }

const breakpoint = 1024

const Figure = ({ node }) => {
  const img = getFluidGatsbyImage(
    node.asset._ref,
    { maxWidth: 1024 },
    sanityConfig
  )

  return (
    <div
      css={css`
        margin: 0;
        margin-top: ${65 / fontSizes[0]}rem;
        margin-bottom: ${56 / 15}rem;

        ${lessThen(breakpoint)} {
          width: calc(100vw - 60px);
          margin-left: calc(50% - 50vw);
          margin-right: calc(50% - 50vw);
        }
      `}
    >
      <div
        css={css`
          position: relative;
          overflow: hidden;

          ${lessThen(breakpoint)} {
            width: 100vw;
          }
        `}
      >
        <figure
          css={css`
            display: inline-grid;
            grid-template-columns: repeat(3, auto);
            grid-template-rows: auto auto;
            margin: 0;
            align-items: center;

            :before {
              max-width: 318px;
              width: ${(210 / 320) * 100}vw;
              height: ${(210 / 320) * 100}vw;
              max-height: 318px;
              background-color: ${colors.veryLightBrown};
              border-radius: 50%;
              content: "";
              display: block;
              grid-column: 2 / span 1;
              grid-row: 1 / span 1;
            }
          `}
        >
          <picture
            css={css`
              max-width: 318px;
              width: ${(210 / 320) * 100}vw;
              height: ${(210 / 320) * 100}vw;
              max-height: 318px;
              display: block;
              overflow: hidden;
              grid-column: 1 / span 1;
              grid-row: 1 / span 1;

              img,
              source {
                object-fit: cover;
                object-position: ${node.hotspot && node.hotspot.x * 100}%
                  ${node.hotspot && node.hotspot.y * 100}%;
                width: 100%;
                height: 100%;
              }
            `}
          >
            <source sizes="" srcSet={img.srcSetWebp} type="image/webp" />

            <img src={img.src} alt={node.alt} sizes="" srcSet={img.srcSet} />
          </picture>

          <figcaption
            css={css`
              font-family: ${fonts.accent};
              font-weight: bold;
              font-size: ${20 / fontSizes[0]}em;
              line-height: ${24 / 20};
              grid-column: 1 / span 3;
              grid-row: 2 / span 1;
              margin-bottom: 0;

              :before {
                content: "—";
                padding-right: 0.5ch;
              }

              ${lessThen(breakpoint)} {
                width: calc(100vw - 60px);
                margin-left: 30px;
                margin-right: 30px;
                margin-top: ${25 / 15}rem;
              }

              ${greaterThen(breakpoint)} {
                grid-column: 2 / span 1;
                grid-row: 1 / span 1;
                margin: 0;
                padding: 0 1em 0 2em;
                max-width: calc(318px - 3em);
                width: calc(${(210 / 320) * 100}vw - 2em);
              }

              ${greaterThen(fontSizes.breakpoint)} {
                font-size: ${24 / fontSizes[1]}em;
              }
            `}
          >
            {node.caption}
          </figcaption>
        </figure>
      </div>
    </div>
  )
}

export default Figure
